import PocketBase from "pocketbase";

export const PB_URL = "https://pocketbase-3mhg.onrender.com";
export const PRODUCTS_COLLECTION = "maisondebijoux_products";

const pb = new PocketBase(PB_URL);

export default pb;
